module.exports = __webpack_public_path__ + "media/images/corporation-7597fb341d92db894fdda01dc1b21925.svg";